<template>
    <div class="block-editor instagram-send-message">
        <div class="editor-row">
            <div class="editor-row-title">Message Type</div>
            <a-select class="classic-new-select" placeholder="Select Message Type" v-model="clone.messageType">
                <a-select-option v-for="messageType in messageTypes" :key="messageType.type"
                                 :value="messageType.type">
                    {{ messageType.text }}
                </a-select-option>
            </a-select>
        </div>
        <div class="editor-row">
            <div class="editor-row-title">Channel</div>
            <a-select class="classic-new-select" placeholder="Select Instagram Channel" v-model="clone.channelId">
                <a-select-option v-for="channel in instagramChannels" :key="channel._id" :value="channel._id">
                    {{ channel.name }}
                </a-select-option>
            </a-select>
        </div>
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">User ID</div>
            <TiptapEditor
                placeholder="User ID"
                :show-attributes="true"
                :max-character-count="500"
                v-model="clone.userId"
            />
        </div>
        <div class="editor-row customize-editor" v-if="clone.messageType === 'text'">
            <div class="editor-row-title">Message</div>
            <TiptapEditor
                placeholder="Message"
                :show-attributes="true"
                :max-character-count="2048"
                v-model="clone.message"
            />
        </div>
        <div
            class="image-picker"
            v-if="clone.messageType === 'image'"
        >
            <div class="editor-row">
                <div class="editor-row-title">Media</div>
                <div class="media-preview" v-if="media">
                    <div class="media-preview-content">
                        <div class="media-image">
                            <img :src="media.data" alt="" />
                        </div>
                        <div class="media-preview-name">
                            {{ media.name }}
                        </div>
                    </div>
                    <div class="media-preview-delete" @click="deleteMedia">
                        <div class="material-icons">delete</div>
                    </div>
                </div>
                <div class="media-drag" v-else>
                    <div class="input">
                        <input type="file" id="media-source" @change="handleFileUpload" />
                    </div>
                    <div class="material-icons">image</div>
                    <div class="content">Click here to upload a picture.</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";
import { mapState } from "vuex";
import AttributePicker from "../pickers/AttributePicker.vue";
import { uploadAsset } from "../../../../../../api/assetUpload";
import axios from "axios";

const log = log2("InstagramSendMessage");
export default {
    name: "InstagramSendMessage",
    components: { AttributePicker, TiptapEditor },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
            media: null,
            messageTypes: [
                {
                    type: "text",
                    text: "Metin",
                },
                {
                    type: "image",
                    text: "Resim",
                },
            ],
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site._id,
            instagramChannels: (state) =>
                state.channel.channels.filter((channel) => channel.type === "instagram" || channel.type === "instagram-v2"),
        }),
    },
    methods: {
        async handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                this.$message.loading("Image uploading, please wait...", 5);

                let path = `${this.siteId}/whatsapp-business/${this.clone.channelId}/assets/`;
                let imgUploadData = await uploadAsset({
                    path,
                    name: file.name,
                    size: file.size,
                    type: "chatbot",
                    mime: file.type,
                    ext: file.name.split(".").pop(),
                });

                await axios({
                    method: imgUploadData.data.method,
                    url: imgUploadData.data.url,
                    data: file,
                    headers: { "Content-Type": file.type },
                });

                this.media = {
                    data: URL.createObjectURL(file),
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    asset: imgUploadData.data.asset,
                };

                this.clone.asset = this.media.asset;
                this.$message.success("Resim başarılı bir şekilde yüklendi.");
            }
        },
        deleteMedia() {
            this.media = null;
            this.clone.asset = null;
        },
    },
    mounted() {
        this.media = this.clone.asset && {
            ...this.clone?.asset,
            data: `${this.clone?.asset.cdnUrl}${this.clone?.asset.id}.${this.clone?.asset.ext}`,
            asset: this.clone?.asset,
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.template-preview-modal {
    .custom-modal-header {
        display: none !important;
    }

    .ant-modal-content {
        background: transparent !important;
        box-shadow: none;
    }

    .ant-modal-body {
        background: transparent !important;
    }

    .custom-modal-body {
        background: transparent !important;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.block-editor.instagram-send-message {
    padding: 20px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: 20px;

    .ant-select {
        width: 100%;
    }

    .ant-spin-container {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    .editor-row {
        width: 100%;

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
            display: flex;
            align-items: center;
            gap: 5px;
        }
    }

    .media-preview {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .media-preview-content {
            display: flex;
            align-items: center;
            gap: 10px;

            .media-preview-name {
                font-weight: bold;
            }

            .media-image img {
                height: 100px;
            }
        }

        .media-preview-delete {
            background: red;
            padding: 5px;
            border-radius: 100%;
            color: white;
            line-height: 0;
        }
    }

    .media-drag {
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 10px;
        border: 1px solid var(--color-border-default);
        padding: 40px;
        cursor: pointer;
        position: relative;

        .input {
            width: 100%;
            height: 100%;

            input {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                opacity: 0;
            }
        }

        .material-icons {
            font-size: 28px;
        }

        .content {
            font-size: 18px;
            font-weight: bold;
        }
    }
}
</style>
